"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SATURDAY: 'saturday',
    FRIDAY: 'friday',
};
